const topbar = {
    docs: '문서',
    help: '도움말',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
